import Vue from 'vue'

Vue.mixin({
  data: () => ({
    globalRules: {
      required: v => !!v || 'Campo obligatorio',

      fileInput: [
        v => !!v || 'File is required',
        v => (v && v.size > 0) || 'File is required'
      ],

      email: v => /.+@.+\..+/.test(v) || 'Email no válido',

      minPassword: v =>
        v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres',

      hasUppercase: v =>
        /[A-Z]/.test(v) || 'Debe contener al menos una mayúscula',

      hasLowercase: v =>
        /[a-z]/.test(v) || 'Debe contener al menos una minúscula',

      hasNumber: v =>
        /[0-9]/.test(v) || 'Debe contener al menos un número',

      hasSpecialChar: v =>
        /[^A-Za-z0-9]/.test(v) || 'Debe contener al menos un carácter especial'
    }
  })
})

